import { render, staticRenderFns } from "./ProjectPropositions.vue?vue&type=template&id=a883ebae&"
import script from "./ProjectPropositions.vue?vue&type=script&lang=js&"
export * from "./ProjectPropositions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPropositions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports